import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { App } from './App';
import './index.css';
import { initTelegramSdk, getStartParam, parseStartParam } from './lib/telegram';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
    environment: import.meta.env.MODE,
  });
}

initTelegramSdk();

const startParam = getStartParam();
const parsed = parseStartParam(startParam);
if (parsed?.type === 'lot') {
  window.history.replaceState(null, '', `/lot/${parsed.id}`);
} else if (parsed?.type === 'ref') {
  localStorage.setItem('cherry_referrer', parsed.id);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
